/**
 * Is a colour or a size of a product retired? Spec 014, FR-1450.
 *
 * The product's list keeps the mark: `"retired": true` on a colour, and the
 * name in `retired_sizes` for a size. It used to be "every variant of it is
 * switched off", which a colour with no variants could never be, so it could
 * never be retired. The database has the same rule in
 * `style_option_is_retired`, and `retire_style_option` keeps the mark and
 * the variants together.
 *
 * One function for the server and the screens, so a choice a form offers is a
 * choice the server accepts.
 */
export type OptionLists = {
  colors?: Array<{ name: string; retired?: boolean }> | null;
  retired_sizes?: string[] | null;
};

export function isRetired(p: OptionLists, kind: 'colour' | 'size', name: string): boolean {
  if (kind === 'colour') return Boolean((p.colors ?? []).find((c) => c.name === name)?.retired);
  return (p.retired_sizes ?? []).includes(name);
}
